import React from "react";
import {
  Datagrid,
  TextField,
  ShowButton,
  EditButton,
  useTranslate,
  FunctionField,
} from "react-admin";
import { JsonField } from "react-admin-json-view";
import {
  DateField,
  CreateOnlyTopToolbar,
  CustomList,
  EmptyMessage,
} from "../../../shared/components/index.js";
import moment from "moment-timezone";
import ClientFilter from "../ClientFilter.js";

const ListClient = (props) => {
  const t = useTranslate();

  return (
    <CustomList
      filters={<ClientFilter {...props} />}
      actions={<CreateOnlyTopToolbar />}
    >
      <Datagrid
        empty={<EmptyMessage />}
        rowClick={false}
        bulkActionButtons={false}
      >
        <TextField source="phone" />
        <TextField source="email" />
        <TextField source="first_name" />
        <TextField source="last_name" />
        <TextField source="middle_name" />
        <FunctionField
          source="sex"
          label="resources.Client.fields.sex.name"
          render={(record) =>
            record.sex && t(`resources.Client.fields.sex.${record.sex}`)
          }
        />
        <FunctionField
          source="date_of_birth"
          render={(record) => {
            if (!record.date_of_birth) {
              return "";
            } else {
              return (
                record &&
                moment.unix(record.date_of_birth / 1000).format("DD-MM-YYYY")
              );
            }
          }}
          label="resources.Client.fields.date_of_birth"
        />

        <FunctionField
          source="status"
          render={(record) =>
            t(`resources.Client.source.status.${record.status}`)
          }
        />
        <JsonField
          reference="Changes"
          source="unconfirmed_changes"
          label="resources.Client.fields.unconfirmed_changes.name"
          reactJsonOptions={{
            name: null,
            collapsed: true,
            enableClipboard: false,
            displayDataTypes: false,
          }}
          sortable={false}
        />
        <DateField source="created_at" />
        <DateField source="updated_at" />
        <FunctionField
          source="blocked_at"
          render={(record) => {
            if (record && record.blocked_at) {
              return <DateField source="blocked_at" />;
            } else {
              return t("");
            }
          }}
          label="resources.Client.source.blocked_at"
        />
        <FunctionField
          source="deleted_at"
          render={(record) => {
            if (record && record.deleted_at) {
              return <DateField source="deleted_at" />;
            } else {
              return t("");
            }
          }}
          label="resources.Client.source.deleted"
        />
        <ShowButton className="button-show" />
        <EditButton className="button-edit" />
      </Datagrid>
    </CustomList>
  );
};

export default ListClient;
